package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config

enum class DeviceTypeEnum(
    val title: String,
    val id: String,
) {
    SELF_CHECKOUT(title = "SelfCheckout", id = "SELF_CHECKOUT"),
    SMART_CHECKOUT(title = "SmartCheckout", id = "SMART_CHECKOUT"),
    MOBILE_WAITER(title = "Mobile Waiter", id = "MOBILE_WAITER"),
    SMART_LABEL(title = "SmartLabel", id = "SMART_LABEL"),
    KDS(title = "KDS", id = "KDS");
}